export default {
  aiSummary: 'AI Summary',
  noisy: 'Noisy',
  loadingSummaries: 'Loading summaries...',
  generating: 'Generating...',
  feedbackOptional: 'Feedback (optional)',
  feedbackPlaceholder: 'What could be improved?',
  done: 'Done',
  generate: 'Generate',
  generalSummary: 'General Summary',
  modelQuality: 'Model Quality',
  baseSales: 'Base Sales',
  competition: 'Competition',
  pricing: 'Pricing',
  distribution: 'Distribution',
  economic: 'Economic',
  instantMarketingSales: 'Instant Marketing Sales',
  seasonality: 'Seasonality',
  componentCorrelations: 'Component Correlations',
  topMediaBySpend: 'Top Media by Spend',
  topMediaByAttribution: 'Top Media by Attribution',
  attributionDisparities: 'Attribution Disparities',
  fastSaturatingMedia: 'Fast Saturating Media',
  saturationAnalysis: 'Saturation Analysis',
  highAndLowRoi: 'High and Low ROAS',
  mediaChannelStrategies: 'Media Channel Strategies',
  mediaChannelCorrelations: 'Media Channel Correlations',
  errorGeneratingSection: 'Error generating this section'
}
